/* wood-miniatures — product landing (wm-). No dependency, loaded with defer. */
(function () {
  'use strict';

  /* ---------- helpers ---------- */
  function rootUrl() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  /* US federal holidays (observed), computed per year. */
  var holidayCache = {};
  function nthWeekday(y, m, wd, n) { var d = new Date(Date.UTC(y, m, 1)); var add = (wd - d.getUTCDay() + 7) % 7; return 1 + add + (n - 1) * 7; }
  function lastWeekday(y, m, wd) { var d = new Date(Date.UTC(y, m + 1, 0)); return d.getUTCDate() - ((d.getUTCDay() - wd + 7) % 7); }
  function observed(y, m, day, out) {
    var wd = new Date(Date.UTC(y, m, day)).getUTCDay();
    var d = new Date(Date.UTC(y, m, day + (wd === 6 ? -1 : wd === 0 ? 1 : 0)));
    out[d.toISOString().slice(0, 10)] = true;
  }
  function holidays(y) {
    if (holidayCache[y]) return holidayCache[y];
    var h = {};
    observed(y, 0, 1, h); observed(y, 5, 19, h); observed(y, 6, 4, h); observed(y, 10, 11, h); observed(y, 11, 25, h);
    observed(y + 1, 0, 1, h); // Jan 1 of next year can be observed on Dec 31
    [[0, 1, 3], [1, 1, 3], [8, 1, 1], [9, 1, 2], [10, 4, 4]].forEach(function (r) {
      h[new Date(Date.UTC(y, r[0], nthWeekday(y, r[0], r[1], r[2]))).toISOString().slice(0, 10)] = true;
    });
    h[new Date(Date.UTC(y, 4, lastWeekday(y, 4, 1))).toISOString().slice(0, 10)] = true; // Memorial Day
    holidayCache[y] = h; return h;
  }
  function isBusinessDay(d) {
    var wd = d.getUTCDay();
    return wd !== 0 && wd !== 6 && !holidays(d.getUTCFullYear())[d.toISOString().slice(0, 10)];
  }
  function addDays(d, n) { var x = new Date(d); x.setUTCDate(x.getUTCDate() + n); return x; }
  function addBusinessDays(d, n) { var x = new Date(d); var added = 0; while (added < n) { x.setUTCDate(x.getUTCDate() + 1); if (isBusinessDay(x)) added++; } return x; }
  /* "Now" in a given time zone, as a UTC date (y/m/d) + hour. */
  function nowIn(tz) {
    var parts = {};
    new Intl.DateTimeFormat('en-US', { timeZone: tz, year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hourCycle: 'h23' })
      .formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    return { date: new Date(Date.UTC(+parts.year, +parts.month - 1, +parts.day)), hour: +parts.hour };
  }
  function fmtDay(d) { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', timeZone: 'UTC' }); }
  function todayISO(tz) { return nowIn(tz || 'America/New_York').date.toISOString().slice(0, 10); }

  /* ---------- product hero ---------- */
  function initPdp(root) {
    if (!root || root.dataset.wmReady) return;
    root.dataset.wmReady = '1';
    var dataEl = root.querySelector('[data-wm-config]');
    if (!dataEl) return;
    var cfg; try { cfg = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var fmt = new Intl.NumberFormat(cfg.locale || 'en-US', { style: 'currency', currency: cfg.currency || 'USD' });
    function money(cents) { return fmt.format(Math.round(cents) / 100); }

    var state = {
      tier: cfg.defaultTier || 'duo', variantId: cfg.product.variantId, price: cfg.product.price,
      compare: cfg.product.compare, available: cfg.product.available, slots: {}, pickerTarget: null
    };

    /* gallery: thumbs, light toggle, swipe */
    var mainImg = root.querySelector('[data-wm-main-img]');
    var mainBox = root.querySelector('.wm-gallery__main');
    var unlit = root.querySelector('[data-wm-unlit]');
    var lightBtn = root.querySelector('[data-wm-gallery-light]');
    var lightLabel = lightBtn && lightBtn.querySelector('[data-wm-gallery-light-label]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-wm-thumb]'));
    function setLit(lit) { if (!mainBox || !lightLabel) return; mainBox.classList.toggle('is-off', !lit); lightLabel.textContent = lit ? lightBtn.dataset.labelOff : lightBtn.dataset.labelOn; }
    function preloadUnlit() { if (unlit && !unlit.getAttribute('src')) unlit.src = unlit.dataset.src; }
    if (unlit && lightBtn) {
      lightBtn.addEventListener('pointerenter', preloadUnlit, { once: true });
      lightBtn.addEventListener('focus', preloadUnlit, { once: true });
      lightBtn.addEventListener('click', function (e) { e.preventDefault(); preloadUnlit(); setLit(mainBox.classList.contains('is-off')); });
    }
    function showThumb(btn) {
      if (!mainImg || !btn) return;
      if (mainBox && unlit) { mainBox.classList.toggle('is-pair', btn.hasAttribute('data-wm-pair')); setLit(true); }
      mainImg.src = btn.dataset.src; mainImg.srcset = btn.dataset.srcset || ''; mainImg.alt = btn.dataset.alt || '';
      thumbs.forEach(function (b) { b.setAttribute('aria-current', 'false'); });
      btn.setAttribute('aria-current', 'true');
      if (btn.scrollIntoView && window.matchMedia('(max-width: 749px)').matches) btn.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
    thumbs.forEach(function (btn) { btn.addEventListener('click', function () { showThumb(btn); }); });
    if (mainBox && thumbs.length > 1) {
      var x0 = null;
      mainBox.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      mainBox.addEventListener('touchend', function (e) {
        if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) < 40) return;
        var i = thumbs.findIndex(function (b) { return b.getAttribute('aria-current') === 'true'; });
        var n = (i + (dx < 0 ? 1 : -1) + thumbs.length) % thumbs.length;
        showThumb(thumbs[n]);
      }, { passive: true });
    }

    /* variant */
    var variantSelect = root.querySelector('[data-wm-variant]');
    if (variantSelect) variantSelect.addEventListener('change', function () {
      var v = cfg.variants.find(function (x) { return String(x.id) === variantSelect.value; });
      if (!v) return;
      state.variantId = v.id; state.price = v.price; state.compare = v.compare; state.available = v.available; state.stock = v.stock;
      render();
    });

    /* tiers */
    root.querySelectorAll('[data-wm-tier-input]').forEach(function (input) {
      input.addEventListener('change', function () { if (input.checked) { state.tier = input.value; render(); } });
    });

    /* picker */
    var picker = root.querySelector('[data-wm-picker]');
    var pk = cfg.picker || {};
    var grid = picker && picker.querySelector('[data-wm-picker-grid]');
    var tabsEl = picker && picker.querySelector('[data-wm-picker-tabs]');
    var pickerReady = null;
    var allowed = (pk.types || '').split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
    function loadPage(page) {
      var url = pk.url + '?section_id=' + encodeURIComponent(pk.section) + '&page=' + page;
      return fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var list = doc.querySelector('[data-wm-picker-items]');
        if (!list) return;
        list.querySelectorAll('[data-wm-pick]').forEach(function (b) {
          if (String(b.dataset.product) === String(pk.exclude)) return;
          if (allowed.length && allowed.indexOf((b.dataset.type || '').toLowerCase()) === -1) return;
          if (pk.family && b.dataset.wmFamily !== pk.family) return; /* same automatic discount only */
          grid.appendChild(b.closest('li'));
        });
        var pages = +list.dataset.pages || 1;
        if (page < pages && page < 10) return loadPage(page + 1);
      });
    }
    function groupOf(btn) {
      var uni = btn.dataset.wmUniverse || '';
      var colls = (btn.dataset.wmColls || '').split(' ');
      if (pk.from && colls.indexOf(pk.from) > -1) return { rank: 0, label: pk.fromLabel || pk.other };
      if (uni) return { rank: 2, label: uni };
      return { rank: 3, label: pk.other };
    }
    function setFilter(label) {
      grid.querySelectorAll('[data-wm-group]').forEach(function (el) { el.hidden = label !== '*' && el.dataset.wmGroup !== label; });
      tabsEl.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.wmFilter === label ? 'true' : 'false'); });
    }
    function buildPicker() {
      var loading = grid.querySelector('[data-wm-picker-loading]'); if (loading) loading.remove();
      var groups = {}, order = [];
      grid.querySelectorAll('[data-wm-pick]').forEach(function (btn) {
        var g = groupOf(btn), key = g.rank + '|' + g.label, li = btn.closest('li');
        if (!groups[key]) { groups[key] = { rank: g.rank, label: g.label, items: [] }; order.push(groups[key]); }
        li.dataset.wmGroup = g.label; groups[key].items.push(li);
      });
      order.sort(function (a, b) { return a.rank - b.rank || a.label.localeCompare(b.label, 'en'); });
      grid.innerHTML = ''; tabsEl.innerHTML = '';
      var labels = ['*'], first = null;
      order.forEach(function (g) {
        var h = document.createElement('li'); h.className = 'wm-picker__group'; h.setAttribute('role', 'presentation');
        h.dataset.wmGroup = g.label; h.textContent = g.label; grid.appendChild(h);
        g.items.forEach(function (li) { grid.appendChild(li); });
        if (labels.indexOf(g.label) === -1) labels.push(g.label);
        if (g.rank === 0 && !first) first = g.label;
      });
      if (!order.length) { var e = document.createElement('li'); e.className = 'wm-picker__loading'; e.textContent = 'No other kits available right now.'; grid.appendChild(e); }
      labels.forEach(function (label) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'wm-picker__tab';
        b.dataset.wmFilter = label; b.textContent = label === '*' ? pk.all : label;
        b.addEventListener('click', function () { setFilter(label); }); tabsEl.appendChild(b);
      });
      setFilter(first || '*');
    }
    function openPicker(slotKey) {
      if (!picker) return;
      if (!pickerReady) pickerReady = loadPage(1).then(buildPicker).catch(buildPicker);
      state.pickerTarget = slotKey;
      if (typeof picker.showModal === 'function') picker.showModal(); else picker.setAttribute('open', '');
    }
    function closePicker() { if (!picker) return; if (typeof picker.close === 'function') picker.close(); else picker.removeAttribute('open'); }
    root.addEventListener('click', function (e) {
      var slotBtn = e.target.closest('[data-wm-slot-open]');
      if (slotBtn) { openPicker(slotBtn.dataset.wmSlotOpen); return; }
      if (e.target.closest('[data-wm-picker-close]')) { closePicker(); return; }
      var item = e.target.closest('[data-wm-pick]');
      if (item && state.pickerTarget) {
        state.slots[state.pickerTarget] = { id: Number(item.dataset.variant), price: Number(item.dataset.price), compare: Number(item.dataset.compare) || 0, title: item.dataset.title, img: item.dataset.img };
        state.pickerTarget = null; closePicker(); render();
      }
    });
    if (picker) picker.addEventListener('click', function (e) { if (e.target === picker) closePicker(); });

    function tierById(id) { return cfg.tiers.find(function (t) { return t.id === id; }) || cfg.tiers[0]; }
    function slotKeys(t) { var k = []; for (var i = 2; i <= t.qty; i++) k.push(t.id + '-' + i); return k; }
    /* Totals: empty slots = same kit (what the cart will receive). Discount = automatic discount amount. */
    function tierTotals(t) {
      var price = state.price, hasCompare = state.compare > state.price, was = hasCompare ? state.compare : state.price;
      slotKeys(t).forEach(function (k) {
        var s = state.slots[k]; var p = s ? s.price : state.price; var c = s ? s.compare : state.compare;
        price += p; was += c > p ? c : p; if (c > p) hasCompare = true;
      });
      var off = t.discount || 0, total = Math.max(0, price - off);
      if (t.qty > 1 && off > 0) return { total: total, was: price, unit: total / t.qty, hasWas: true, save: price - total };
      /* 1 kit: sale price only (no strike-through, no saving shown). */
      return { total: total, was: was, unit: total / t.qty, hasWas: false, save: 0 };
    }

    function render() {
      var active = tierById(state.tier);
      cfg.tiers.forEach(function (t) {
        var card = root.querySelector('[data-wm-tier="' + t.id + '"]'); if (!card) return;
        card.classList.toggle('is-active', t.id === state.tier);
        var tt = tierTotals(t);
        var q = function (s) { return card.querySelector(s); };
        if (q('[data-wm-total]')) q('[data-wm-total]').textContent = money(tt.total);
        if (q('[data-wm-was]')) q('[data-wm-was]').textContent = tt.hasWas ? money(tt.was) : '';
        if (q('[data-wm-save]')) q('[data-wm-save]').textContent = tt.save > 1 ? cfg.text.save + ' ' + money(tt.save) : '';
        if (q('[data-wm-unit]') && t.qty > 1) q('[data-wm-unit]').textContent = money(tt.unit) + ' ' + cfg.text.each;
        slotKeys(t).forEach(function (k) {
          var slot = card.querySelector('[data-wm-slot="' + k + '"]'); if (!slot) return;
          var s = state.slots[k], img = slot.querySelector('.wm-slot__img'), name = slot.querySelector('[data-wm-slot-name]'), btn = slot.querySelector('[data-wm-slot-open]');
          if (s) {
            img.classList.remove('wm-slot__img--empty'); img.textContent = '';
            if (s.img) { var im = document.createElement('img'); im.src = s.img; im.alt = ''; im.loading = 'lazy'; im.width = 44; im.height = 44; img.appendChild(im); }
            name.hidden = false; name.textContent = '';
            var strong = document.createElement('span'); strong.className = 'wm-slot__name'; strong.textContent = s.title;
            var change = document.createElement('button'); change.type = 'button'; change.className = 'wm-slot__change'; change.setAttribute('data-wm-slot-open', k); change.textContent = cfg.text.change;
            name.appendChild(strong); name.appendChild(document.createElement('br')); name.appendChild(change);
            btn.hidden = true;
          } else {
            img.classList.add('wm-slot__img--empty'); img.textContent = '?'; name.hidden = true; btn.hidden = false;
          }
        });
      });
      var tt = tierTotals(active);
      /* gifts */
      var ship = root.querySelector('[data-wm-gift-ship]');
      if (ship) {
        var shipOn = cfg.freeShipping > 0 && tt.total >= cfg.freeShipping;
        ship.classList.toggle('is-unlocked', shipOn);
        ship.querySelector('[data-wm-gift-tag]').textContent = shipOn ? cfg.text.included : ship.dataset.lockedLabel;
      }
      root.querySelectorAll('[data-wm-gift]').forEach(function (g) {
        var on = active.qty >= Number(g.dataset.wmGift);
        g.classList.toggle('is-unlocked', on);
        var tag = g.querySelector('[data-wm-gift-tag]'); if (tag) tag.textContent = on ? cfg.text.free : g.dataset.lockedLabel;
      });
      /* CTA + stock + sticky */
      root.querySelectorAll('[data-wm-cta-label]').forEach(function (el) { el.textContent = state.available ? cfg.text.add : cfg.text.soldOut; });
      root.querySelectorAll('[data-wm-cta-price]').forEach(function (el) { el.textContent = state.available ? ' · ' + money(tt.total) : ''; });
      root.querySelectorAll('[data-wm-cta]').forEach(function (b) { b.disabled = !state.available; });
      var stock = root.querySelector('[data-wm-stock]');
      if (stock) {
        var v = cfg.variants.find(function (x) { return x.id === state.variantId; }) || {};
        stock.classList.toggle('is-out', !state.available);
        stock.textContent = state.available ? cfg.text.inStock : cfg.text.outOfStock;
        stock.hidden = state.available ? !v.stock : false;
      }
      root.querySelectorAll('[data-wm-sticky-price]').forEach(function (el) { el.textContent = money(tt.total); });
    }

    /* add to cart: all bundle items in one request, then Dawn cart drawer (or cart page) */
    var msg = root.querySelector('[data-wm-msg]');
    function addToCart() {
      var t = tierById(state.tier);
      var items = [{ id: state.variantId, quantity: 1 }];
      slotKeys(t).forEach(function (k) { var s = state.slots[k]; items.push({ id: s ? s.id : state.variantId, quantity: 1 }); });
      var merged = [];
      items.forEach(function (it) { var m = merged.find(function (x) { return x.id === it.id; }); if (m) m.quantity++; else merged.push({ id: it.id, quantity: it.quantity }); });
      var drawer = document.querySelector('cart-drawer');
      var body = { items: merged };
      if (drawer && drawer.getSectionsToRender) { body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; }); body.sections_url = window.location.pathname; }
      var buttons = root.querySelectorAll('[data-wm-cta]');
      buttons.forEach(function (b) { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
      if (msg) msg.textContent = '';
      fetch(rootUrl() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function (res) {
          var tt = tierTotals(t);
          var payload = { bundle_qty: t.qty, bundle_tier: t.id, value: tt.total / 100, currency: cfg.currency, product_id: cfg.product.id, items: merged };
          try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('wm_bundle_add_to_cart', payload); } catch (e) {}
          try { if (window.dataLayer) window.dataLayer.push({ event: 'wm_bundle_add_to_cart', wm_bundle: payload }); } catch (e) {}
          try { if (typeof publish === 'function' && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'wm-product', productVariantId: state.variantId, cartData: res }); } catch (e) {}
          if (drawer && drawer.renderContents && res.sections) {
            res.id = state.variantId;
            drawer.classList.remove('is-empty');
            drawer.renderContents(res);
          } else {
            window.location.href = rootUrl() + 'cart';
          }
        })
        .catch(function (err) { if (msg) msg.textContent = (err && (err.description || err.message)) || cfg.text.error; })
        .finally(function () { buttons.forEach(function (b) { b.disabled = !state.available; b.removeAttribute('aria-busy'); }); });
    }
    root.querySelectorAll('[data-wm-cta]').forEach(function (b) { b.addEventListener('click', addToCart); });

    /* delivery dates, store time zone. Shipped: US business days. Delivered: calendar days after the order day (single source: section settings delivery_min / delivery_max). */
    var sh = cfg.shipping || {};
    if (root.querySelector('[data-wm-ship]')) {
      var now = nowIn(sh.tz || 'America/New_York');
      /* Before the cutoff on a business day, processing starts today; otherwise on the next business day. */
      var start = now.date;
      if (!isBusinessDay(start) || now.hour >= (sh.cutoffHour || 14)) start = addBusinessDays(start, 1);
      var shipDate = addBusinessDays(start, sh.prepMax || 2);
      var delMin = addDays(now.date, sh.deliveryMin != null ? sh.deliveryMin : 6);
      var delMax = addDays(now.date, sh.deliveryMax != null ? sh.deliveryMax : 8);
      root.querySelectorAll('[data-wm-ship-date]').forEach(function (el) { el.textContent = fmtDay(shipDate); });
      root.querySelectorAll('[data-wm-del-min]').forEach(function (el) { el.textContent = fmtDay(delMin); });
      root.querySelectorAll('[data-wm-del-max]').forEach(function (el) { el.textContent = fmtDay(delMax); });
      var xmas = root.querySelector('[data-wm-xmas]');
      if (xmas && cfg.xmasEnd) xmas.hidden = todayISO(sh.tz) > cfg.xmasEnd;
    }

    /* sticky bar */
    var sticky = root.querySelector('[data-wm-sticky]');
    var mainCta = root.querySelector('[data-wm-cta-main]');
    if (sticky && mainCta) {
      /* Shown once the main button has scrolled above the viewport. Position check on scroll
         (rAF-throttled) so instant jumps (anchors, back-to-top) are handled too. */
      var stickyOn = null, ticking = false;
      var updateSticky = function () {
        ticking = false;
        var show = mainCta.getBoundingClientRect().bottom < 0;
        if (show === stickyOn) return; stickyOn = show;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        sticky.querySelectorAll('button').forEach(function (b) { b.tabIndex = show ? 0 : -1; });
      };
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(updateSticky); } }, { passive: true });
      window.addEventListener('resize', updateSticky, { passive: true });
      updateSticky();
    }
    render();
  }

  /* ---------- description "Read more" ---------- */
  function initDesc(root) {
    if (root.dataset.wmReady) return; root.dataset.wmReady = '1';
    var body = root.querySelector('[data-wm-desc-body]'), btn = root.querySelector('[data-wm-desc-toggle]');
    if (!body || !btn) return;
    root.classList.add('is-ready');
    if (body.scrollHeight <= body.clientHeight + 2) { root.classList.add('is-open'); return; }
    btn.hidden = false;
    btn.addEventListener('click', function () {
      var open = !root.classList.contains('is-open');
      root.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? btn.dataset.labelLess : btn.dataset.labelMore;
    });
  }

  /* ---------- cross-sell fallback: Shopify recommendations ---------- */
  function initReco(el) {
    if (el.dataset.wmReady) return; el.dataset.wmReady = '1';
    fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-wm-reco-filled]');
      if (fresh && fresh.querySelector('.wm-x__card')) el.replaceWith(fresh); else { var s = el.closest('.wm-x-section'); if (s) s.hidden = true; }
    }).catch(function () {});
  }

  /* ---------- offers with an end date (badge, bar, banner) + honest countdown ---------- */
  function initOffers(scope) {
    scope.querySelectorAll('[data-wm-offer-end]').forEach(function (o) {
      var end = o.dataset.wmOfferEnd; if (!end) return;
      var endAt = new Date(end + 'T23:59:59-05:00');
      if (new Date() > endAt) { o.remove(); return; }
      var cd = o.querySelector('[data-wm-countdown]'); if (!cd) return;
      (function tick() {
        var ms = endAt - new Date();
        if (ms <= 0) { o.remove(); return; }
        var d = Math.floor(ms / 864e5), h = Math.floor(ms / 36e5) % 24, m = Math.floor(ms / 6e4) % 60, s = Math.floor(ms / 1e3) % 60;
        cd.textContent = (d ? d + 'd ' : '') + String(h).padStart(2, '0') + 'h ' + String(m).padStart(2, '0') + 'm ' + String(s).padStart(2, '0') + 's';
        setTimeout(tick, 1000);
      })();
    });
  }

  /* Promotion heading of the bundle block: back to the default text once the end date is reached (cached pages too). */
  function initHeadings(scope) {
    scope.querySelectorAll('[data-wm-heading-until]').forEach(function (el) {
      if (todayISO('America/New_York') >= el.dataset.wmHeadingUntil) el.textContent = el.dataset.wmHeadingDefault;
    });
  }

  function initSwitches(scope) {
    scope.querySelectorAll('[data-wm-switch-at]').forEach(function (el) {
      var d = el.dataset.wmSwitchAt, t2 = el.dataset.wmText2;
      if (d && t2 && new Date() > new Date(d + 'T23:59:59-05:00')) el.textContent = t2;
    });
  }

  function boot() {
    initHeadings(document);
    initSwitches(document);
    document.querySelectorAll('[data-wm-pdp]').forEach(initPdp);
    document.querySelectorAll('[data-wm-desc]').forEach(initDesc);
    document.querySelectorAll('[data-wm-reco]').forEach(initReco);
    initOffers(document);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
